import regions from './regions'
import countries from './countries'
export { default as regions } from './regions'
export { default as countries } from './countries'

export const regionCodes = regions.map(region => region.code)
export const countryCodes = countries.map(country => country.code)
